/**
 * In-memory salon app bootstrap token (org-scoped session token).
 * Never persisted in sessionStorage — XSS / shared-device risk.
 */

import { SALON_APP_SESSION_TOKEN_KEY } from '../config/salonApp';

let activeToken = '';

export function getSalonAppSessionToken() {
  return activeToken;
}

export function setSalonAppSessionToken(value) {
  activeToken = typeof value === 'string' ? value.trim() : '';
}

export function clearSalonAppSessionToken() {
  activeToken = '';
}

/** Remove legacy sessionStorage key from prior builds. */
export function purgeLegacySalonAppSessionTokenStorage() {
  try {
    sessionStorage.removeItem(SALON_APP_SESSION_TOKEN_KEY);
  } catch {
    /* ignore */
  }
}
